<script setup lang="ts">
import { onMounted } from "vue";

useHead({
  title: "Shop",
});

// Function to insert the script block
const insertShopifyScript = () => {
  const scriptContent = `
(function () {
  var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
  if (window.ShopifyBuy) {
    if (window.ShopifyBuy.UI) {
      ShopifyBuyInit();
    } else {
      loadScript();
    }
  } else {
    loadScript();
  }
  function loadScript() {
    var script = document.createElement('script');
    script.async = true;
    script.src = scriptURL;
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
    script.onload = ShopifyBuyInit;
  }
  function ShopifyBuyInit() {
    var client = ShopifyBuy.buildClient({
      domain: 'wildcare-tasmania.myshopify.com',
      storefrontAccessToken: 'dd5e0b00367998ba35e4caaf149c78cc',
    });
    ShopifyBuy.UI.onReady(client).then(function (ui) {
      ui.createComponent('collection', {
        id: '484540842265',
        node: document.getElementById('collection-component-1726616551809'),
        moneyFormat: '%24%7B%7Bamount%7D%7D',
        options: {
  "product": {
    "styles": {
      "product": {
        "@media (min-width: 601px)": {
          "max-width": "calc(25% - 20px)",
          "margin-left": "20px",
          "margin-bottom": "50px",
          "width": "calc(25% - 20px)"
        },
        "img": {
          "height": "calc(100% - 15px)",
          "position": "absolute",
          "left": "0",
          "right": "0",
          "top": "0"
        },
        "imgWrapper": {
          "padding-top": "calc(75% + 15px)",
          "position": "relative",
          "height": "0"
        }
      },
      "title": {
        "font-family": "Gill Sans, sans-serif",
        "font-weight": "normal"
      },
      "button": {
        "font-family": "Gill Sans, sans-serif",
        ":hover": {
          "background-color": "#005851"
        },
        "background-color": "#00625a",
        ":focus": {
          "background-color": "#005851"
        },
        "border-radius": "8px"
      },
      "price": {
        "font-family": "Gill Sans, sans-serif"
      },
      "compareAt": {
        "font-family": "Gill Sans, sans-serif"
      },
      "unitPrice": {
        "font-family": "Gill Sans, sans-serif"
      }
    },
    "buttonDestination": "modal",
    "contents": {
      "options": false
    },
    "text": {
      "button": "View product"
    }
  },
  "productSet": {
    "styles": {
      "products": {
        "@media (min-width: 601px)": {
          "margin-left": "-20px"
        }
      }
    }
  },
  "modalProduct": {
    "contents": {
      "img": false,
      "imgWithCarousel": true,
      "button": false,
      "buttonWithQuantity": true
    },
    "styles": {
      "product": {
        "@media (min-width: 601px)": {
          "max-width": "100%",
          "margin-left": "0px",
          "margin-bottom": "0px"
        }
      },
      "button": {
        "font-family": "Gill Sans, sans-serif",
        ":hover": {
          "background-color": "#005851"
        },
        "background-color": "#00625a",
        ":focus": {
          "background-color": "#005851"
        },
        "border-radius": "8px"
      },
      "title": {
        "font-family": "Helvetica Neue, sans-serif",
        "font-weight": "bold",
        "font-size": "26px",
        "color": "#4c4c4c"
      },
      "price": {
        "font-family": "Helvetica Neue, sans-serif",
        "font-weight": "normal",
        "font-size": "18px",
        "color": "#4c4c4c"
      },
      "compareAt": {
        "font-family": "Helvetica Neue, sans-serif",
        "font-weight": "normal",
        "font-size": "15.299999999999999px",
        "color": "#4c4c4c"
      },
      "unitPrice": {
        "font-family": "Helvetica Neue, sans-serif",
        "font-weight": "normal",
        "font-size": "15.299999999999999px",
        "color": "#4c4c4c"
      }
    },
    "text": {
      "button": "Add to cart"
    }
  },
  "option": {},
  "cart": {
    "styles": {
      "button": {
        "font-family": "Gill Sans, sans-serif",
        ":hover": {
          "background-color": "#005851"
        },
        "background-color": "#00625a",
        ":focus": {
          "background-color": "#005851"
        },
        "border-radius": "8px"
      }
    },
    "text": {
      "total": "Subtotal",
      "button": "Checkout"
    }
  },
  "toggle": {
    "styles": {
      "toggle": {
        "font-family": "Gill Sans, sans-serif",
        "background-color": "#00625a",
        ":hover": {
          "background-color": "#005851"
        },
        ":focus": {
          "background-color": "#005851"
        }
      }
    }
  }
},
      });
    });
  }
})();
  `;

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.innerHTML = scriptContent;
  document.body.appendChild(script);
};

// Insert the script when the component is mounted
onMounted(() => {
  // Create the container div
  const container = document.createElement("div");
  container.id = "collection-component-1726616551809";

  const shopElement = document.getElementById("shop-element");
  if (shopElement) {
    shopElement.appendChild(container);
  }
  // Insert the Shopify script
  insertShopifyScript();
});
</script>

<template>
  <div class="bg-white">
    <CommonPageBanner size="small" class="bg-accentDark" image="/banner-tasmanian-beach.jpg" :local-asset="true">
      <div class="font-script text-3xl font-bold text-white">Wildcare</div>
      <h1 class="text-4xl font-semibold md:text-6xl xl:text-banner">Shop</h1>
    </CommonPageBanner>
    <CommonContainer>
      <p class="py-8 text-xl lg:py-16">
        All purchases support the work of Wildcare Tasmania – we are a not-for-profit charity.<br/>  
        Prices include GST and postage costs – there are no additional amounts added at check-out.<br/>
        Each product is dispatched by the related Wildcare group. If ordering multiple items, it is possible that they will arrive seperately.
      </p>
      <div id="shop-element"></div>
    </CommonContainer>
  </div>
</template>
